// The tripwire's words, in one place for both sides (step 1, docs/frontend-v3/no-snapshot.md):
// data/snapshot.ts throws them when live mode reads the snapshot, and the clean build
// (snapshot-gzip.plugin.ts) fails if they're still in its bundle — the bundler drops code no
// live path can reach, so the words surviving means some live path still calls readSnapshot().
// Plain ASCII, so the minified bundle keeps them byte-for-byte.

export const SNAPSHOT_TRIPWIRE = "live mode must use the API only";
